let _client

function setApolloProvider(apolloProviderRef) {
  const { client } = apolloProviderRef.props
  _client = client
}

function clearCache() {
  if (!_client) return
  _client.clearStore()
}

export default {
  setApolloProvider,
  clearCache
}
